import type { Database } from 'node-sqlite3-wasm';

export function contentHashFileHasTags(db: Database, contentHash: string, filePath: string): boolean {
  const row = db.get(
    'SELECT 1 as ok FROM symbol_index_tag WHERE content_hash = ? AND file_path = ? LIMIT 1',
    [contentHash, filePath],
  ) as { ok: number } | null;
  return row != null;
}

export function contentHashFileHasImports(db: Database, contentHash: string, filePath: string): boolean {
  const row = db.get(
    'SELECT 1 as ok FROM symbol_index_import WHERE content_hash = ? AND file_path = ? LIMIT 1',
    [contentHash, filePath],
  ) as { ok: number } | null;
  return row != null;
}
